import React, { useState } from 'react';
import { Check } from '@mui/icons-material';
import format from 'string-template';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { DateFormat } from '../../../../utils/date';
import { TimeDurationFormat } from '../../../../utils/time';
import CalDotComMeetingCancelModal
from '../../../../CoachTools/components/Leads/components/CalDotComMeetingCancelModal';
import LoadingOverlay from '../../../../CoachTools/components/LoadingOverlay';

import {
  SuccessContainer,
  SuccessIcon,
  SuccessTitle,
  SuccessMessage,
  DetailsContainer,
  DetailsRow,
  DetailsLabel,
  DetailsValue,
  StyledButton,
} from './styles';
import texts from './texts.json';

const SLOT_DURATION_MINUTES = 20;

const BookingSuccess = ({
  leadName,
  selectedSlot,
  timeZone,
  leadData,
  setBookingSuccess,
  setBookingCancelled,
  userName,
}) => {
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const startTime = selectedSlot
    ? moment(selectedSlot.slotTimeInTz)
    : moment(leadData.calendlyMeetingTime).tz(timeZone);

  return (
    <SuccessContainer>
      <SuccessIcon>
        <Check />
      </SuccessIcon>
      <SuccessTitle>{texts.title}</SuccessTitle>
      <SuccessMessage>{texts.message}</SuccessMessage>
      <DetailsContainer>
        <DetailsRow>
          <DetailsLabel>{texts.event}</DetailsLabel>
          <DetailsValue>{format(texts.eventDetails, { leadName })}</DetailsValue>
        </DetailsRow>
        <DetailsRow>
          <DetailsLabel>{texts.time}</DetailsLabel>
          <DetailsValue>
            <div>
              {startTime.format(DateFormat.FULL_WEEKDAY_MONTH_FORMAT)}
            </div>
            <div>
              {format(texts.timeDetails, {
                fromTime: startTime.format(TimeDurationFormat.TWELVE_HOUR_FORMAT),
                toTime: moment(startTime).add(SLOT_DURATION_MINUTES, 'minutes')
                  .format(TimeDurationFormat.TWELVE_HOUR_FORMAT),
                timeZone,
              })}
            </div>
          </DetailsValue>
        </DetailsRow>
        <DetailsRow>
          <DetailsLabel>{texts.user}</DetailsLabel>
          <DetailsValue>{leadName}</DetailsValue>
        </DetailsRow>
      </DetailsContainer>
      <StyledButton onClick={() => setShowConfirmationDialog(true)}>
        {texts.cancelBooking}
      </StyledButton>
      {showConfirmationDialog && (
        <CalDotComMeetingCancelModal
          leadId={leadData.id}
          onClose={() => setShowConfirmationDialog(false)}
          setLoading={setIsLoading}
          onCancelBooking={() => {
            setShowConfirmationDialog(false);
            setBookingSuccess(false);
            setBookingCancelled(true);
          }}
          userName={userName}
        />
      )}
      <LoadingOverlay isLoading={isLoading} />
    </SuccessContainer>
  );
};

BookingSuccess.propTypes = {
  leadName: PropTypes.string.isRequired,
  selectedSlot: PropTypes.object,
  timeZone: PropTypes.string.isRequired,
  leadData: PropTypes.object.isRequired,
  setBookingSuccess: PropTypes.func.isRequired,
  setBookingCancelled: PropTypes.func.isRequired,
  userName: PropTypes.string,
};

BookingSuccess.defaultProps = {
  selectedSlot: null,
  userName: '',
};

export default BookingSuccess;
